import {Deserializable} from '../deserializable';
import {LoaiKeHoach} from '../danhmuc/loaikehoach';
import {KeHoachFile} from '../kehoach/kehoachfile';

export  class VanBanPhoCap implements Deserializable
{
  public  id: number;
  public  soVaoSo: string;
  public  soHieuGoc: string;
  public  tongFile: number;
  public  ngayNhan: string;
  public  ngayVaoSo: string;
  public  trichYeu: string;
  public  noiPhatHanh: string;
  public  nguoiKy: string;
  public  kieuVanBan: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
